import { Screen } from 'components/screen';
import createAccountSentScreenHTML = require('html-loader!html/create-account-sent-screen');
/**
 * Once a new account is created show them the success screen
 */
export class CreateAccountSentScreen extends Screen {
  public static readonly screenID: string = 'create-account-sent';

  public async renderImpl(): Promise<void> {
    this.containerEl.innerHTML = createAccountSentScreenHTML;
  }

  protected getTitle() {
    return 'Welcome Email Sent';
  }
}
